const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.company_tags/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.company_tags/LIST_REQUEST':
      return {
        ...state,
        loading: true,
        error: false,
      };
    case 'table.company_tags/LIST_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        loading: false,
        error: false,
      };
    case 'table.company_tags/LIST_FAILURE':
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
